<!-- 任务耗时分布 -->
<template>
  <div>
    <a-card size="small" :bordered="false">
      <template slot="title">
        <span style="margin-right: 4px">任务耗时分布</span>
        <a-popover title="报表说明" placement="topLeft">
          <template slot="content">
            <p>时间: 任务上线时间</p>
            <p>描述: 所选时间段各任务的耗时分布</p>
            <p>&emsp;&emsp;&ensp;预开发时间: 任务创建时间 -> 任务开始开发时间</p>
            <p>&emsp;&emsp;&ensp;开发耗时: 任务开始开发时间 -> 第一次任务开发完成时间</p>
            <p>&emsp;&emsp;&ensp;提审耗时: 第一次任务开发完成时间 -> 最后一次任务交付流程提审时间</p>
            <p>&emsp;&emsp;&ensp;qa耗时: qa耗时 -> 最后一次任务交付流程提审时间 -> qa验收完成时间</p>
            <p>&emsp;&emsp;&ensp;demo耗时:  qa验收完成时间 -> demo发布完成时间</p>
            <p>&emsp;&emsp;&ensp;online耗时:  demo发布完成时间 -> prod发布完成时间</p>
            <p>排序: 任务耗时总时长正序（默认）</p>
            <p>操作: 点击柱状图可跳转至任务详情页</p>
          </template>
          <a-icon type="question-circle" />
        </a-popover>
      </template>
      <div :id="chartId" :style="{ height: height, width: width }" />
    </a-card>
    <div v-if="data && data.length > 0 && data[index].taskList">
      <task-list-time-modal ref="taskListModal" :task-list="data[index].taskList" />
    </div>
  </div>
</template>
<script>
import { taskTakeTimeDistribution } from '@/api/data/task';
import TaskListTimeModal from '@/pages/data/task/components/TaskListTimeModal';
export default {
  components: { TaskListTimeModal },
  props: {
    width: {
      type: String,
      default: '100%'
    },
    height: {
      type: String,
      default: '300px'
    },
    filterForm: {
      type: Object,
      default: () => {
        return {};
      }
    }
  },
  data() {
    return {
      showModal: 'person',
      chartId: 'task-take-time-distribution',
      myChart: null,
      titleDict: {},
      data: [],
      index: 0,
      option: {
        tooltip: {
          trigger: 'axis',
          axisPointer: {
            type: 'shadow'
          }
          // formatter: params => {
          //   const dataIndex = params[0].dataIndex;
          //   let formatter = '<div><b>' + params[0].name + '</b><br>';
          //   formatter += `${params[0].marker} ${params[0].seriesName}: <span style="color: #5A6FC0;"><b>${params[0].value}</b></span> 小时 <br>`;
          //   formatter += `${params[1].marker} ${params[1].seriesName}: <span style="color: #00B83F;"><b>${params[1].value}</b></span> 小时 <br>`;
          //   formatter += `${params[2].marker} ${params[2].seriesName}: <span style="color: #F2CA6B;"><b>${params[2].value}</b></span> 小时 <br>`;
          //   formatter += `${params[3].marker} ${params[3].seriesName}: <span style="color: #5A6FC0;"><b>${params[3].value}</b></span> 小时 <br>`;
          //   formatter += `${params[4].marker} ${params[4].seriesName}: <span style="color: #00B83F;"><b>${params[4].value}</b></span> 小时 <br>`;
          //   formatter += `${params[5].marker} ${params[5].seriesName}: <span style="color: #F2CA6B;"><b>${params[5].value}</b></span> 小时 <br>`;
          //   formatter += '</div>';
          //   return formatter;
          // }
        },
        grid: {
          left: '2%',
          right: '3%',
          bottom: '16%',
          containLabel: true
        },
        xAxis: {
          type: 'category',
          data: []
        },
        legend: {},
        yAxis: {},
        series: [],
        dataZoom: [
          {
            show: true,
            realtime: true,
            button: 0,
            height: 18,
            startValue: 0,
            endValue: 14
          }
        ]
      },
      xAxisData: [],
      series: []
    };
  },
  watch: {
    filterForm() {
      this.getData();
    },
    '$store.state.collapsed'() {
      setTimeout(() => {
        this.$nextTick(() => {
          this.myChart.resize();
        });
      }, 200);
    }
  },
  mounted() {
    // let echarts = require('echarts');
    const echarts = require('echarts/lib/echarts');
    require('echarts/lib/chart/bar'); // 柱状图
    // 下面的是需要的提示框
    require('echarts/lib/component/tooltip');
    require('echarts/lib/component/legend');
    require('echarts/lib/component/grid');
    require('echarts/lib/component/dataZoom');
    this.myChart = echarts.init(document.getElementById(this.chartId));
    const self = this;
    this.myChart.getZr().on('click', param => {
      const pointInPixel = [param.offsetX, param.offsetY];
      // 判断给定的点是否在指定的坐标系或者系列上
      if (self.myChart.containPixel('grid', pointInPixel)) {
        // 获取到点击的 x轴 下标  转换为逻辑坐标
        const index = self.myChart.convertFromPixel({ seriesIndex: 0 }, pointInPixel)[0];
        self.onDetail(index);
      }
    });
  },
  beforeDestroy() {
    /* 页面组件销毁的时候，移除绑定的监听resize事件，防止内存泄漏和额外CPU或GPU占用*/
    window.removeEventListener('resize', () => {
      this.myChart.resize();
    });
  },
  methods: {
    drawChart() {
      this.myChart.setOption(this.option, true);
      this.$nextTick(() => {
        this.myChart.resize();
      });
    },
    getData() {
      taskTakeTimeDistribution({ ...this.filterForm }).then(res => {
        this.data = res.data.items;
        const x_axis = [];
        const preStartTime = [];
        const devSpendTime = [];
        const toQaTime = [];
        const qaSpendTime = [];
        const demoSpendTime = [];
        const onlineSpendTime = [];
        this.data.forEach(el => {
          x_axis.push(el.itemName);
          preStartTime.push((el.preStartTime / el.total).toFixed(2));
          devSpendTime.push((el.devSpendTime / el.total).toFixed(2));
          toQaTime.push((el.toQaTime / el.total).toFixed(2));
          qaSpendTime.push((el.qaSpendTime / el.total).toFixed(2));
          demoSpendTime.push((el.demoSpendTime / el.total).toFixed(2));
          onlineSpendTime.push((el.onlineSpendTime / el.total).toFixed(2));
        });
        this.option.xAxis.data = x_axis;
        this.option.series = [
          {
            type: 'bar',
            name: '预开发时间',
            data: preStartTime,
            stack: 'cost'
          },
          {
            type: 'bar',
            name: '开发耗时',
            data: devSpendTime,
            stack: 'cost'
          },
          {
            type: 'bar',
            name: '提审耗时',
            data: toQaTime,
            stack: 'cost'
          },
          {
            type: 'bar',
            name: 'qa耗时',
            data: qaSpendTime,
            stack: 'cost'
          },
          {
            type: 'bar',
            name: 'demo耗时',
            data: demoSpendTime,
            stack: 'cost'
          },
          {
            type: 'bar',
            // label: {
            //   show: true,
            //   position: 'inside',
            //   formatter: params => (params.value > 0 ? params.value : ' ')
            // },
            name: 'online耗时',
            data: onlineSpendTime,
            stack: 'cost'
          }
        ];
        this.drawChart();
      });
    },

    onDetail(index) {
      this.index = index;
      this.$refs.taskListModal.open();
    }
    // onDetail(index) {
    //   const link = this.$router.resolve({
    //     name: 'page:project:task:detail',
    //     params: { project_id: this.data[index].project_id },
    //     query: { taskId: this.data[index].id }
    //   }).href;
    //   window.open(link, '_blank');
    // }
  }
};
</script>

<style lang="less" scoped>
.customer-card {
  margin-bottom: 10px;
}
</style>
